export default __webpack_public_path__ + "static/media/criancas-felizes.e94d6d78.svg";